var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 20C4.97778 20 4.66667 19.8667 4.4 19.6C4.13333 19.3333 4 19.0222 4 18.6667V5.33333C4 4.97778 4.13333 4.66667 4.4 4.4C4.66667 4.13333 4.97778 4 5.33333 4H10.8667C11.2349 4 11.5333 4.29848 11.5333 4.66667C11.5333 5.03486 11.2349 5.33333 10.8667 5.33333H5.33333V18.6667H18.6667V13.1333C18.6667 12.7651 18.9651 12.4667 19.3333 12.4667C19.7015 12.4667 20 12.7651 20 13.1333V18.6667C20 19.0222 19.8667 19.3333 19.6 19.6C19.3333 19.8667 19.0222 20 18.6667 20H5.33333ZM10.3 14.6555C10.0371 14.9185 9.60993 14.916 9.35007 14.6499C9.09449 14.3883 9.09695 13.9697 9.35559 13.7111L17.7333 5.33333H13.5333C13.1651 5.33333 12.8667 5.03486 12.8667 4.66667C12.8667 4.29848 13.1651 4 13.5333 4H19C19.5523 4 20 4.44772 20 5V10.4667C20 10.8349 19.7015 11.1333 19.3333 11.1333C18.9651 11.1333 18.6667 10.8349 18.6667 10.4667V6.28889L10.3 14.6555Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/new-tab.90dd7561f82969e57fd2482bc2ee8fd9.svg";
export { ForwardRef as ReactComponent };